import type { SITE_CONSTRAINTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-constraints-card/site-constraints-card.fr.ts";

import { ESiteConstraint } from "~domain/sites/models/site-constraint-model.ts";

const constraints: Record<ESiteConstraint, string> = {
  [ESiteConstraint.HAS_DEFINITIVE_DEACTIVATION]: "Definitive deactivation",
  [ESiteConstraint.HAS_TEMPORARY_DEACTIVATION]: "Temporary deactivation",
  [ESiteConstraint.HAS_LINK_DEACTIVATION]: "Deactivation by links",
  [ESiteConstraint.HAS_PLANNING]: "Planning",
  [ESiteConstraint.HAS_MODULATION_LIMITATION]: "Modulations adjusting",
};

export const SITE_CONSTRAINTS_CARD_ENGLISH_LOCALE = {
  title: "Production Constraints",
  noConstraint: "No constraint",
  constraints,
} satisfies typeof SITE_CONSTRAINTS_CARD_FRENCH_LOCALE;
